import React, { useEffect, useRef } from 'react'
import Chart from 'chart.js'

const LineGraph = props => {
  let {
    toolTipLabel,
    labels,
    data,
    storeGraphRef,
    yAxesLabel,
    xAxesLabel,
    clickedDay,
    backToMonthView
  } = props
  const currentChart = useRef(null)
  const chartRef = useRef(null)

  labels = labels.map(label => label.split(' ')[0])
  useEffect(() => {
    currentChart.current = new Chart(chartRef.current, {
      type: 'line',
      data: {
        labels: labels,
        datasets: [
          {
            data: data,
            fill: false,
            label: toolTipLabel,
            borderColor: '#0065B2',
            pointBackgroundColor: '#0065B2',
            radius: 4,
            hoverRadius: 8
          }
        ]
      },
      options: {
        events: ['mousemove'], // this is needed, otherwise onHover is not fired
        onHover: (event, chartElement) => {
          event.target.style.cursor = chartElement[0] ? 'pointer' : 'default'
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: yAxesLabel
              }
            }
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: xAxesLabel
              }
            }
          ]
        }
      }
    })
    storeGraphRef(currentChart.current)
    // eslint-disable-next-line
  }, [data])

  return (
    <canvas
      ref={chartRef}
      onClick={e => {
        if (xAxesLabel === 'Month-Day') clickedDay(currentChart.current.getElementAtEvent(e)[0])
        else backToMonthView()
      }}
    />
  )
}

export default LineGraph
